import React, { useState } from 'react';
import AuthLayout from './AuthLayout';
import OtpStep from './OtpStep';
import useAuthRedirect from './useAuthRedirect';
import { Button, Checkbox, PhoneField } from '../../components/common';
import authApi from '../../api/auth/authApi';
import { DEFAULT_COUNTRY_CODE, DEMO_LOGIN } from '../../utils/constants';
import { USE_MOCK } from '../../api/client';
import * as v from '../../utils/validators';

export default function SmsLoginPage() {
  const { complete } = useAuthRedirect();
  const [step, setStep] = useState('phone');
  const [countryCode, setCountryCode] = useState(USE_MOCK ? DEMO_LOGIN.countryCode : DEFAULT_COUNTRY_CODE);
  const [phone, setPhone] = useState(USE_MOCK ? DEMO_LOGIN.phone : '');
  const [remember, setRemember] = useState(true);
  const [error, setError] = useState('');
  const [hint, setHint] = useState('');
  const [loading, setLoading] = useState(false);

  const requestCode = async () => {
    const res = await authApi.requestOtp({ countryCode, phone, purpose: 'login' });
    setHint(res.hint);
  };

  const sendCode = async (e) => {
    e.preventDefault();
    const err = v.phone(phone);
    setError(err);
    if (err) return;
    setLoading(true);
    try {
      await requestCode();
      setStep('code');
    } catch (ex) {
      setError(ex.message);
    }
    setLoading(false);
  };

  const verify = async (code) => {
    setLoading(true);
    setError('');
    try {
      const session = await authApi.verifyOtp({ countryCode, phone, code, purpose: 'login' });
      complete(session, remember);
    } catch (ex) {
      setError(ex.message);
      setLoading(false);
    }
  };

  if (step === 'code') {
    return (
      <AuthLayout title="Enter your code" onBack={() => setStep('phone')}>
        <OtpStep
          countryCode={countryCode}
          phone={phone}
          hint={hint}
          error={error}
          loading={loading}
          submitLabel="Log in"
          onVerify={verify}
          onResend={requestCode}
        />
      </AuthLayout>
    );
  }

  return (
    <AuthLayout title="Log in with SMS" subtitle="We’ll text a one-time code to your mobile number.">
      <form onSubmit={sendCode} noValidate>
        <PhoneField
          countryCode={countryCode}
          onCountryCodeChange={setCountryCode}
          value={phone}
          onChange={setPhone}
          error={error}
        />
        <Checkbox
          className="u-mt-6"
          label="Keep me logged in on this device"
          checked={remember}
          onChange={(e) => setRemember(e.target.checked)}
        />
        <Button type="submit" block className="u-mt-6" loading={loading}>Send code</Button>
      </form>
    </AuthLayout>
  );
}
